@if (outletsGroup$ | async; as outletsGroup) {
  @if (Object.keys(outletsGroup).length > 1 || outletsGroup[Object.keys(outletsGroup)[0]].length > 1) {
    <mat-form-field appearance="outline">
      <mat-label i18n="@@Address">Address</mat-label>
      @if (selectedOutlet$ | async) {
        <mat-select [formControl]="outletCtrl">
          @if (selectedOutlet) {
            <mat-select-trigger>
              @if (selectedOutlet.addressDetails) {
                <div class="h4">{{ selectedOutlet.addressDetails.city }}, {{ selectedOutlet.addressDetails.streetLine }}</div>
              }
              @if (!selectedOutlet.addressDetails) {
                <div class="h4">{{ selectedOutlet.address }}</div>
              }
            </mat-select-trigger>
          }
          <mat-option>
            <ngx-mat-select-search
              #selectFilter
              [clearSearchInput]="false"
              placeholderLabel="Search"
              i18n-placeholderLabel="@@Search"
              noEntriesFoundLabel="No matches found"
              i18n-noEntriesFoundLabel="@@NoMatchesFound"
            ></ngx-mat-select-search>
          </mat-option>
          <cdk-virtual-scroll-viewport itemSize="42" minBufferPx="200" maxBufferPx="400" [style.height.px]="5*42" class="example-viewport">
            <mat-optgroup *cdkVirtualFor="let key of Object.keys(outletsGroup)" [label]="key">
              @for (outlet of outletsGroup[key] | filter:'address':selectFilter.value; track outlet) {
                <mat-option
                  (onSelectionChange)="onChangeMenu($event, outlet)"
                  [value]="outlet"
                  >
                  @if (outlet.addressDetails) {
                    <div class="h4">{{ outlet.addressDetails.city }}, {{ outlet.addressDetails.streetLine }}</div>
                  }
                  @if (!outlet.addressDetails) {
                    <div class="h4">{{ outlet.address }}</div>
                  }
                  @if (outletsSchedule && outletsSchedule[outlet.storeId]; as schedule) {
                    <div class="schedule-status">
                      <div class="schedule-status__time">{{ schedule.open }} – {{ schedule.close }}</div>
                      @if (schedule.isOpen) {
                        <div class="schedule-status__status" i18n="@@Open">Open</div>
                      }
                      @if (!schedule.isOpen) {
                        <div class="schedule-status__status _error" i18n="@@Close">Close</div>
                      }
                    </div>
                  }
                </mat-option>
              }
            </mat-optgroup>
          </cdk-virtual-scroll-viewport>
          @if (selectedOutlet) {
            <mat-option hidden [value]="selectedOutlet">
              @if (selectedOutlet.addressDetails) {
                <div class="h4">{{ selectedOutlet.addressDetails.city }}, {{ selectedOutlet.addressDetails.streetLine }}</div>
              }
              @if (!selectedOutlet.addressDetails) {
                <div class="h4">{{ selectedOutlet.address }}</div>
              }
            </mat-option>
          }
        </mat-select>
      }
    </mat-form-field>
  } @else {
    <div class="value-cell">
      <div class="value-cell__title h5" i18n="@@RestaurantAddress">Restaurant address</div>
      <div class="value-cell__text">{{ pickupAddress$ | async }}</div>
    </div>
  }
}

